import { transformCrmCustomerMeOrderResponse } from '../order/transformers.js';
import { transformCrmCustomerMeReturnResponse, transformCrmCustomerMeReturnsEstimateRequest, transformCrmCustomerMeReturnsTypeRequest, transformReturnsItemsRequest, transformCrmCustomerMeReturnsTypeResponse } from '../returns/transformers.js';
import 'axios';
import { transformCustomerAddressEasyReturnRequest } from '../transformers/customer/index.js';
import { transformOrder } from '../transformers/order/index.js';

const transformCrmGuestOrderResponse = (order)=>transformCrmCustomerMeOrderResponse(order);
const transformCrmGuestReturnsResponse = (data)=>data.map((item)=>transformCrmCustomerMeReturnResponse(item));
const transformCrmGuestReturnResponse = (item)=>transformCrmCustomerMeReturnResponse(item);
const transformSalesCheckoutGiftCardsDataResponse = ({ code , date_created , date_expires , balance , currency_code  })=>({
        code,
        balance,
        currencyCode: currency_code,
        createdAt: date_created,
        dateExpires: date_expires
    });
const transformCrmGuestReturnsEstimateRequest = (data)=>transformCrmCustomerMeReturnsEstimateRequest(data);
const transformCrmGuestReturnsTypeRequest = (data)=>transformCrmCustomerMeReturnsTypeRequest(data);
const transformSalesReturnsAttributeResponse = (data)=>data.map(({ attribute_code , type , values  })=>({
            attributeCode: attribute_code,
            type,
            values: values.map(({ label , value , options =null  })=>({
                    label,
                    value,
                    options: options?.map(({ value , text , qty  })=>({
                            value: parseInt(value),
                            text,
                            qty
                        })) || null
                }))
        }));
const transformCrmGuestReturnsRequestRequest = ({ orderId , items , easyReturn , easyReturnAddress , orderNumber  })=>({
        order_id: orderId,
        order_increment_id: orderNumber,
        items: transformReturnsItemsRequest(items),
        ...easyReturn && easyReturnAddress ? {
            easy_return: easyReturn,
            /*
				easy_return_pickup_address: transformCustomerAddressRequest(easyReturnAddress),
				*/ /**
				 * The problem is that crm/customer/me/returns/request and crm/customer/me/address need two different formats for the region field
				 * For this reason we can't use the same request transform
				 * Once they are uniformed, we can remove the following line and uncomment the previous one
				 */ easy_return_pickup_address: transformCustomerAddressEasyReturnRequest(easyReturnAddress)
        } : null
    });
const transformSalesPaymentCallbackVerifyResponse = (response)=>{
    if (typeof response === 'string') {
        return {
            error: {
                statusCode: 500,
                name: 'Error',
                message: response
            }
        };
    }
    const { status , message , order , payment  } = response;
    return {
        status,
        message,
        payment,
        order: order ? transformOrder(order) : undefined
    };
};
const transformSalesPaymentThreedsVerifyResponse = ({ status , message , payment , order  })=>({
        status,
        message,
        payment,
        order: transformOrder(order)
    });
// TODO: check payload during payment method
const transformSalesPaymentCallbackVerifyRequest = (data)=>data;
// TODO: check payload during payment method
const transformSalesPaymentThreedsRequest = (data)=>data;
const transformCrmGuestReturnsTypeResponse = (data)=>transformCrmCustomerMeReturnsTypeResponse(data);

export { transformCrmGuestOrderResponse, transformCrmGuestReturnResponse, transformCrmGuestReturnsEstimateRequest, transformCrmGuestReturnsRequestRequest, transformCrmGuestReturnsResponse, transformCrmGuestReturnsTypeRequest, transformCrmGuestReturnsTypeResponse, transformSalesCheckoutGiftCardsDataResponse, transformSalesPaymentCallbackVerifyRequest, transformSalesPaymentCallbackVerifyResponse, transformSalesPaymentThreedsRequest, transformSalesPaymentThreedsVerifyResponse, transformSalesReturnsAttributeResponse };
